export const ReferenceDateDimension = "ReferenceDate";
export var MeasureSeriesSortingType;
(function (MeasureSeriesSortingType) {
    MeasureSeriesSortingType["Asc"] = "Asc";
    MeasureSeriesSortingType["Desc"] = "Desc";
    MeasureSeriesSortingType["Esg"] = "Esg";
})(MeasureSeriesSortingType || (MeasureSeriesSortingType = {}));
export var VisitNodePassage;
(function (VisitNodePassage) {
    VisitNodePassage["Always"] = "Always";
    VisitNodePassage["NodeFirst"] = "NodeFirst";
    VisitNodePassage["Leaf"] = "Leaf";
    VisitNodePassage["NodeLast"] = "NodeLast";
    VisitNodePassage["RootLast"] = "RootLast";
})(VisitNodePassage || (VisitNodePassage = {}));
export var WidgetsLayout;
(function (WidgetsLayout) {
    WidgetsLayout[WidgetsLayout["all"] = 0] = "all";
    WidgetsLayout[WidgetsLayout["myPositionsOnly"] = 1] = "myPositionsOnly";
    WidgetsLayout[WidgetsLayout["wholeFundOnly"] = 2] = "wholeFundOnly";
})(WidgetsLayout || (WidgetsLayout = {}));
